import React, { useState } from "react";
import {
  formatCurrency,
  formatDateTime,
  getStatusIcon,
  mapStatusToBootstrap,
} from "../../components/Constants/Constants";
import { Modal, Button } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";

import "./SettlementDetails.css";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import OrderDetails from "../Orders/OrderDetails";
import { useSettlementDetails } from "../../customHooks/Settlements/useSettlementDetails";
import AppLoader from "../../components/AppLoader/appLoader";
// import UnAuthorized from "../UnAuthorized/UnAuthorized";
// import usePermission from "../../utils/usePermission";
import { ArrowLeft } from "lucide-react";

function SettlementDetails() {
  const {
    settlementId,
    settlementData,
    error,
    settlementSummary,
    handleToggleOrderDetails,
    renderOrderIds,
    showOrderDetails,
    setShowOrderDetails,
    selectedOrderId,
    setSelectedOrderId,
    selectedSettlement,
    loading,
    setLoading,
    handleLatestSettlementRequest,
    handleMiscSettlementRequest,
    miscDetails,
    setMiscDetails,
    showMiscModal,
    setShowMiscModal,
    handleConfirmAction,
    handleCloseModal,
    handleOpenModal,
    handleGoBack,
  } = useSettlementDetails();

  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [showSellerErrorMessage, setSellerShowErrorMessage] = useState(false);
  const [showProviderErrorMessage, setProviderShowErrorMessage] =
    useState(false);

  const handleViewErrorMessage = () => {
    setShowErrorMessage((prev) => !prev);
  };

  const handleSellerViewErrorMessage = () => {
    setSellerShowErrorMessage((prev) => !prev);
  };
  const handleProviderViewErrorMessage = () => {
    setProviderShowErrorMessage((prev) => !prev);
  };

  // const canViewSettlementDetails = usePermission("SETTLEMENT_DETAILS_VIEW");
  //console.log("selectedSettlement", selectedSettlement);

  return (
    <>
      {/* {canViewSettlementDetails ? ( */}
      <div>
        {loading ? (
          <AppLoader />
        ) : (
          <>
            <div className="settlement-container d-flex flex-column mt-2">
              <button
                className="btn btn-link text-primary p-0 d-flex align-items-center text-decoration-none me-3"
                onClick={handleGoBack}
                style={{ fontSize: "16px", fontWeight: "500" }}
                aria-label="Go back to orders list"
              >
                <ArrowLeft size={20} style={{ marginRight: "5px" }} />
                Back
              </button>
              <div className="card card-custom mb-2">
                <div className="card-body">
                  <div className="row g-4 mb-2">
                    <div className="col-md-3 col-sm-6">
                      <div className="settlement-overview-label">
                        Settlement ID
                      </div>
                      <div className="settlement-overview-value">
                        {settlementSummary?.settlement_id}
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                      <div className="settlement-overview-label">Collector</div>
                      <div className="settlement-overview-value">
                        {settlementSummary?.collector_id}
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                      <div className="settlement-overview-label">
                        Order Count
                      </div>
                      <div className="settlement-overview-value">
                        {settlementSummary?.order_count}
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                      <div className="settlement-overview-label">
                        Settlement Type
                      </div>
                      <div className="settlement-overview-value">
                        {settlementSummary?.settlement_type}
                      </div>
                    </div>
                  </div>
                  <div className="row g-4">
                    <div className="col-md-3 col-sm-6">
                      <div className="settlement-overview-label">
                        Transaction ID
                      </div>
                      <div className="settlement-overview-value">
                        {settlementSummary?.settlement_txn_id}
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                      <div className="settlement-overview-label">
                        Receiver ID
                      </div>
                      <div className="settlement-overview-value">
                        {settlementSummary?.receiver_id}
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                      <div className="settlement-overview-label">
                        Total Settled Amount
                      </div>
                      <div className="settlement-overview-value amount-highlight">
                        {formatCurrency(
                          settlementSummary?.totat_settled_amount,
                        )}
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                      <div className="settlement-overview-label">
                        Created At
                      </div>
                      <div className="settlement-overview-value">
                        {formatDateTime(
                          settlementSummary?.settlement_created_at,
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex flex-fill overflow-hidden">
                <div className="order-sidebar d-flex flex-column">
                  <div className="p-2 border-bottom  bg-light">
                    <h6 className="mb-0 fw-semibold text-muted text-uppercase small">
                      Order IDs
                    </h6>
                  </div>
                  <div className="flex-fill overflow-auto">
                    {renderOrderIds().map((orderId) => (
                      <div
                        key={orderId}
                        className={`order-item p-2 ${
                          selectedOrderId === orderId ? "active" : ""
                        }`}
                        onClick={() => setSelectedOrderId(orderId)}
                      >
                        <div className="fw-medium text-dark small">
                          {orderId}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {selectedSettlement && (
                  <div className="flex-fill px-4 overflow-auto">
                    <div>
                      <div className="bg-white d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center">
                          <h6 className="card-title fw-semibold">
                            Settlement Details
                          </h6>
                        </div>

                        <div className="d-flex justify-content-end">
                          <button
                            className="btn btn-refresh btn-sm d-flex align-items-center text-white"
                            onClick={handleLatestSettlementRequest}
                          >
                            Request Latest Status
                          </button>
                          {selectedSettlement?.settlement_status ===
                            "SETTLED" && (
                            <button
                              className="btn btn-refresh btn-sm text-white ms-2" // ms-2 adds margin to the left of the second button
                              onClick={handleOpenModal} // Open the confirmation modal
                            >
                              Request Miscellaneous Settlement
                            </button>
                          )}
                        </div>
                      </div>
                      {/* Summary + Details Row: Settlement Summary, Futuresoft, Your Details */}
                      <div className="row g-4">
                        {/* Settlement Summary (column 1) */}
                        <div className="col-12 col-md-4">
                          <div className="card settlement-detail-card h-100">
                            <div className="settlement-card-header">
                              <h6 className="settlement-card-title">
                                Settlement Summary
                              </h6>
                            </div>
                            <div className="settlement-card-body">
                              <div className="settlement-field">
                                <span className="settlement-label">
                                  Settlement ID
                                </span>
                                <span className="settlement-value">
                                  {selectedSettlement?.settlement_id}
                                </span>
                              </div>
                              <div className="settlement-field settlement-field-row">
                                <span className="settlement-label">
                                  Order ID
                                </span>
                                <span className="settlement-value text-end">
                                  {selectedSettlement?.order_id}
                                </span>
                              </div>
                              <div className="settlement-field settlement-field-row">
                                <span className="settlement-label">Amount</span>
                                <span className="settlement-value text-success">
                                  {formatCurrency(
                                    selectedSettlement?.inter_participant_amount,
                                  )}
                                </span>
                              </div>
                              <div className="settlement-field settlement-field-row">
                                <span className="settlement-label">Status</span>
                                <div
                                  className={`settlement-status ${mapStatusToBootstrap(selectedSettlement?.inter_participant_status)}`}
                                >
                                  {getStatusIcon(
                                    selectedSettlement?.inter_participant_status,
                                  )}
                                  &nbsp;
                                  {selectedSettlement?.inter_participant_status}
                                </div>
                              </div>
                              <div className="settlement-field settlement-field-row">
                                <span className="settlement-label">
                                  Reference Number
                                </span>
                                <span className="settlement-value text-end">
                                  {selectedSettlement?.settlement_reference_no ||
                                    "N/A"}
                                </span>
                              </div>
                              {selectedSettlement?.inter_participant_error && (
                                <div
                                  className="settlement-field settlement-field-row settlement-error-section"
                                  style={{ marginBottom: "0px" }}
                                >
                                  <span className="settlement-label">
                                    Error Code
                                  </span>
                                  <span className="settlement-value d-flex align-items-center gap-2">
                                    {selectedSettlement?.inter_participant_error
                                      ?.code || "--"}
                                    {selectedSettlement?.inter_participant_error
                                      ?.message && (
                                      <a
                                        href="#"
                                        className="errorMessage text-decoration-none"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleViewErrorMessage();
                                        }}
                                      >
                                        {showErrorMessage ? (
                                          <AiOutlineUp size={12} />
                                        ) : (
                                          <AiOutlineDown size={12} />
                                        )}
                                      </a>
                                    )}
                                  </span>
                                </div>
                              )}
                              {showErrorMessage && (
                                <div className="settlement-error-message">
                                  {
                                    selectedSettlement?.inter_participant_error
                                      ?.message
                                  }
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Futuresoft Settlement Details (column 2) */}
                        <div className="col-12 col-md-4">
                          <div className="card settlement-detail-card h-100">
                            <div className="settlement-card-header">
                              <h6 className="settlement-card-title">
                                Futuresoft Settlement Details
                              </h6>
                            </div>
                            <div className="settlement-card-body">
                              <div className="settlement-field settlement-field-row">
                                <span className="settlement-label">
                                  Ref Number
                                </span>
                                <span className="settlement-value text-end">
                                  {selectedSettlement?.self_reference_no ||
                                    "N/A"}
                                </span>
                              </div>
                              <div className="settlement-field settlement-field-row">
                                <span className="settlement-label">Status</span>
                                <div
                                  className={`settlement-status ${mapStatusToBootstrap(selectedSettlement?.self_status)}`}
                                >
                                  {getStatusIcon(
                                    selectedSettlement?.self_status,
                                  )}
                                  &nbsp;{selectedSettlement?.self_status}
                                </div>
                              </div>
                              <div className="settlement-field settlement-field-row">
                                <span className="settlement-label">Amount</span>
                                <span className="settlement-value text-success">
                                  {formatCurrency(
                                    selectedSettlement?.self_amount,
                                  )}
                                </span>
                              </div>

                              {selectedSettlement?.self_error && (
                                <div
                                  className="settlement-field settlement-field-row settlement-error-section"
                                  style={{ marginBottom: "0px" }}
                                >
                                  <span className="settlement-label">
                                    Error Code
                                  </span>
                                  <span className="settlement-value d-flex align-items-center gap-2">
                                    {selectedSettlement?.self_error?.code ||
                                      "--"}
                                    {selectedSettlement?.self_error
                                      ?.message && (
                                      <a
                                        href="#"
                                        className="errorMessage text-decoration-none"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleSellerViewErrorMessage();
                                        }}
                                      >
                                        {showSellerErrorMessage ? (
                                          <AiOutlineUp size={12} />
                                        ) : (
                                          <AiOutlineDown size={12} />
                                        )}
                                      </a>
                                    )}
                                  </span>
                                </div>
                              )}

                              {showSellerErrorMessage && (
                                <div className="settlement-error-message">
                                  {selectedSettlement?.self_error?.message}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Your Details (column 3) */}
                        <div className="col-12 col-md-4">
                          <div className="card settlement-detail-card h-100">
                            <div className="settlement-card-header">
                              <h6 className="settlement-card-title">
                                Your Details
                              </h6>
                            </div>
                            <div className="settlement-card-body">
                              <div className="settlement-field settlement-field-row">
                                <span className="settlement-label">
                                  Provider ID
                                </span>
                                <span className="settlement-value">
                                  {selectedSettlement?.provider?.provider_id ||
                                    "N/A"}
                                </span>
                              </div>
                              <div className="settlement-field settlement-field-row">
                                <span className="settlement-label">Status</span>
                                <div
                                  className={`settlement-status ${mapStatusToBootstrap(selectedSettlement?.provider_status)}`}
                                >
                                  {getStatusIcon(
                                    selectedSettlement?.provider_status,
                                  )}
                                  &nbsp;{selectedSettlement?.provider_status}
                                </div>
                              </div>
                              <div className="settlement-field settlement-field-row">
                                <span className="settlement-label">
                                  Provider Name
                                </span>
                                <span className="settlement-value text-end">
                                  {selectedSettlement?.provider
                                    ?.provider_name || "N/A"}
                                </span>
                              </div>
                              <div className="settlement-field settlement-field-row">
                                <span className="settlement-label">Amount</span>
                                <span className="settlement-value text-success">
                                  {formatCurrency(
                                    selectedSettlement?.provider_amount || 0,
                                  )}
                                </span>
                              </div>
                              <div className="settlement-field settlement-field-row">
                                <span className="settlement-label">
                                  Bank Details
                                </span>
                                <span className="settlement-value text-end">
                                  {selectedSettlement?.provider?.bank_details
                                    ? `${selectedSettlement?.provider?.bank_details?.account_no} / ${selectedSettlement?.provider?.bank_details?.ifsc_code}`
                                    : "N/A"}
                                </span>
                              </div>

                              {selectedSettlement?.provider_error && (
                                <div
                                  className="settlement-field settlement-field-row settlement-error-section"
                                  style={{ marginBottom: "0px" }}
                                >
                                  <span className="settlement-label">
                                    Error Code
                                  </span>
                                  <span className="settlement-value d-flex align-items-center gap-2">
                                    {selectedSettlement?.provider_error?.code ||
                                      "--"}
                                    {selectedSettlement?.provider_error
                                      ?.message && (
                                      <a
                                        href="#"
                                        className="errorMessage text-decoration-none"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleProviderViewErrorMessage();
                                        }}
                                      >
                                        {showProviderErrorMessage ? (
                                          <AiOutlineUp size={12} />
                                        ) : (
                                          <AiOutlineDown size={12} />
                                        )}
                                      </a>
                                    )}
                                  </span>
                                </div>
                              )}

                              {showProviderErrorMessage && (
                                <div className="settlement-error-message">
                                  {selectedSettlement?.provider_error?.message}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div className="text-center mt-3">
                          <button
                            className="btn btn-outline-primary"
                            onClick={handleToggleOrderDetails}
                            style={{ fontSize: "14px" }}
                          >
                            {showOrderDetails
                              ? "Hide Order Details"
                              : "View Order Details"}
                          </button>

                          {showOrderDetails && (
                            <div className="container-fluid mt-3">
                              <OrderDetails
                                orderId={selectedOrderId}
                                hideHeaderSection={true}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {showMiscModal && (
              <Modal show={showMiscModal} onHide={handleCloseModal} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>
                    <strong>
                      Are you sure you want to request{" "}
                      <span style={{ backgroundColor: "yellow" }}>
                        Miscellaneous Status
                      </span>
                      ?
                    </strong>
                  </p>

                  <div className="mt-3">
                    {/* Self Settlement */}
                    <h6
                      className="mb-2"
                      style={{ textDecoration: "underline" }}
                    >
                      Self Settlement
                    </h6>
                    <div className="flex-wrap" style={{ columnGap: "20px" }}>
                      <div className="mb-2">
                        <strong>Self Status:</strong>{" "}
                        {/* Display Self Status */}
                        {miscDetails?.self?.status || "--"}
                      </div>
                      <div className="mb-2">
                        <strong>Self Amount:</strong>{" "}
                        {formatCurrency(miscDetails?.self?.amount ?? 0)}
                      </div>
                    </div>

                    {/* Provider Details */}
                    <h6
                      className="mt-3 mb-2"
                      style={{ textDecoration: "underline" }}
                    >
                      Provider Details
                    </h6>
                    <div className="d-flex flex-column gap-2">
                      <div className="flex-wrap" style={{ columnGap: "20px" }}>
                        <div className="mb-2">
                          <strong>Provider Name:</strong>{" "}
                          {miscDetails?.provider?.provider_name || "--"}
                        </div>
                        <div className="mb-2">
                          <strong>Provider Status:</strong>{" "}
                          {/* Display Provider Status */}
                          {miscDetails?.provider?.status || "--"}
                        </div>
                        <div className="mb-2">
                          <strong>Provider Amount:</strong>{" "}
                          {formatCurrency(
                            miscDetails?.provider?.provider_amount ?? 0,
                          )}
                        </div>
                      </div>
                      <div
                        className="d-flex flex-wrap"
                        style={{ columnGap: "20px" }}
                      >
                        <div className="mb-2">
                          <strong>Account No:</strong>{" "}
                          {miscDetails?.provider?.bank_details?.account_no ||
                            "--"}
                        </div>
                        <div className="mb-2">
                          <strong>IFSC Code:</strong>{" "}
                          {miscDetails?.provider?.bank_details?.ifsc_code ||
                            "--"}
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseModal}>
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={handleConfirmAction}>
                    OK
                  </Button>
                </Modal.Footer>
              </Modal>
            )}
          </>
        )}
      </div>
      {/* // ) : (
      //   <UnAuthorized />
      // )} */}
    </>
  );
}

export default SettlementDetails;
